import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { colors, radii } from '../../styles/tokens';

export type ToolStatus = 'Live' | 'Mock' | 'WIP' | 'Needs API Key' | 'Partial';

const statusStyles: Record<
  ToolStatus,
  { bgcolor: string; color: string; border: string }
> = {
  Live: {
    bgcolor: alpha(colors.success, 0.12),
    color: '#1F5C43',
    border: alpha(colors.success, 0.35),
  },
  Mock: {
    bgcolor: alpha(colors.warning, 0.12),
    color: '#8A5E0B',
    border: alpha(colors.warning, 0.35),
  },
  WIP: {
    bgcolor: alpha(colors.textSecondary, 0.12),
    color: '#6E5F4B',
    border: alpha(colors.textSecondary, 0.3),
  },
  'Needs API Key': {
    bgcolor: alpha(colors.info, 0.12),
    color: '#14544A',
    border: alpha(colors.info, 0.35),
  },
  // Retained for back-compat with tools mid-migration; not part of the canonical set.
  Partial: {
    bgcolor: alpha(colors.warning, 0.12),
    color: '#8A5E0B',
    border: alpha(colors.warning, 0.35),
  },
};

export interface StatusBadgeProps {
  status: ToolStatus;
  size?: 'small' | 'medium';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'small' }) => {
  const style = statusStyles[status];

  return (
    <Chip
      label={status}
      size={size}
      sx={{
        height: size === 'small' ? 22 : 26,
        fontSize: size === 'small' ? '0.6875rem' : '0.75rem',
        fontWeight: 600,
        borderRadius: `${radii.badge}px`,
        bgcolor: style.bgcolor,
        color: style.color,
        border: `1px solid ${style.border}`,
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
};
